import "core-js/features/";
import "regenerator-runtime/runtime";
import "classlist-polyfill";
import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./luris.css";
import * as serviceWorker from "./serviceWorker";

// semantic-ui
import "semantic-ui-css-offline/semantic.min.css";

//ol css
import "ol/ol.css";
import "store/sis/css/ol.scss";

// Router
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

// Redux
import store from "./store";
import { Provider } from "react-redux";

import Map from "components/map/index";
import DefaultLayout from "components/main/index";
import Notice from "components/board/index";
import NoticeDetail from "components/board/detail/NoticeDetail";
import Info from "components/info/index";
import Landing from "components/landing/LandingPage";
import Reference from "components/reference/index";
import ReferenceDetail from "components/reference/detail/ReferenceDetail";
import NotFound from "components/error/index";

class RedirectToBackend404 extends React.Component{
	componentDidMount(){
		//window.location.href=`http://localhost:8097${window.location.pathname}`;
		//window.location.href='/error';
		//window.location.href=window.location.pathname;
		//window.location.href=`${window.location.origin}${window.location.pathname}`;
	}
	render(){
		return null;
	}
}

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			{/*<Route exact path="/" component={Landing} />*/}
			<Route exact path="/" render={() => {
				//if (window.location.href.split("/")[3] !== "") {
				//	return <Redirect to="/404" />; // 404 페이지로 리다이렉트
				//}
				return <DefaultLayout />;
			}} />
			{/*<Route path="/mapMain" component={Map} exact />*/}
			<Route path="/mapMain" exact render={(props)=>
				<Map{...props}/>}
			/>
			<Route path="/mapMain/:x/:y/:z" component={Map} />
			<Route path="/info" component={Info} />
			<Switch>
				<Route path="/notice" component={Notice} exact />
				<Route path="/notice/:noticeId" component={NoticeDetail} />
				<Route path="/reference" component={Reference} exact/>
				<Route path="/reference/:noticeId" component={ReferenceDetail} />
				{/* <Route component={NotFound}	/> */}
			</Switch>
			
			{/* <Redirect path="/" to="/mapMain" /> */}
		</BrowserRouter>
	</Provider>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
